const worker = new Worker(new URL('../../workers/markdown-webworker.js', import.meta.url), { type: 'module' })

const TIMEOUT_LIMIT = 20000

export async function md(markdown: string, options: StructuredSerializeOptions): Promise<any> {
  return new Promise((resolve, reject) => {
    var timeout = setTimeout(() => {
      reject('Marked took too long!')
    }, TIMEOUT_LIMIT)

    worker.onmessage = e => {
      clearTimeout(timeout)
      resolve(e.data)
    }

    worker.postMessage({
      content: markdown,
      options
    })
  })
}
